import { trackBannerRequestOfferClick } from "~/app/analytics/ga/affiliate";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { CART_PAGE } from "~/utils/url/staticUrls";

import classes from "~/features/affiliate/components/AffiliateSalesPartnerBanner/components/AffiliateRequestOfferBanner.module.less";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Button } from "~/common/mui";
import { Permission, userHasPermission } from "~/domains/user/utils/permissions";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";

interface Props {
  className?: string;
}

export const AffiliateRequestOfferBanner = ({ className }: Props) => {
  const { t } = useTranslation();
  const isTablet = useIsMinTabletSize();
  return (
    <div className={classNames(classes.containerGray, className)}>
      <p className={classes.text}>
        {userHasPermission(Permission.ADD_TO_CART)
          ? t("affiliateSalesPartner.banner.new.text.wishlist")
          : t("affiliateSalesPartner.banner.text.wishlist")}
      </p>
      <Button
        className={classNames(classes.button, !isTablet && "mt-3")}
        onClick={() => {
          trackBannerRequestOfferClick();
          redirectToUrl(CART_PAGE);
        }}
        data-test-id={"banner-partner-request-offer"}
      >
        {t("affiliateSalesPartner.banner.button.requestOffer")}
      </Button>
    </div>
  );
};
